import BaseService from "../BaseService";
import http from "../HttpService";
import { API_BASE_URL_ENV } from "helpers/common";

const apiEndpoint = API_BASE_URL_ENV() + "/sales-developer/user/profile";

export default class extends BaseService {
    constructor() {
        super(apiEndpoint);
    }

    getProfile=()=>{
        return http.get(apiEndpoint) 
    }

    update(data) {
        const body = { ...data };
        return http.post(apiEndpoint, body);
    }
}
